import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import HttpService from '../../services/httpService';
import { ROLENAME, junkReasons } from '../../utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import {
    Typography,
    Box,
    IconButton,
    Tooltip,
    CircularProgress
} from "@material-ui/core";
import moment from 'moment';
// Material icons throughout instead of the Ant Design outlined set. The two
// families have different stroke weights and corner radii, so mixing them with
// the MUI controls already on this page made it look assembled from spare
// parts - the same swap made across the other redesigned pages.
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';
import StorefrontOutlinedIcon from '@material-ui/icons/StorefrontOutlined';
import DateRangeOutlinedIcon from '@material-ui/icons/DateRangeOutlined';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import GetAppIcon from '@material-ui/icons/GetApp';
import TuneIcon from '@material-ui/icons/Tune';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import GraphicEqOutlinedIcon from '@material-ui/icons/GraphicEqOutlined';
import InboxOutlinedIcon from '@material-ui/icons/InboxOutlined';
import CloseIcon from '@material-ui/icons/Close';
import PlayArrowRoundedIcon from '@material-ui/icons/PlayArrowRounded';
import PauseRoundedIcon from '@material-ui/icons/PauseRounded';
import RefreshIcon from '@material-ui/icons/Refresh';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

// Brand orange - sampled from the actual Decorpot logo, same palette used
// across the rest of the app's recently-redesigned pages.
const ORANGE = "#F47E44";
const ORANGE_DARK = "#c1531f";
const ORANGE_LIGHT = "#fff1ea";
const HEADER_GRADIENT = `linear-gradient(135deg, ${ORANGE_DARK} 0%, ${ORANGE} 60%, #ff9c66 100%)`;
const GREEN = "#1e8449";
const GREEN_GRADIENT = `linear-gradient(135deg, #146c43, ${GREEN})`;
const RED = "#c0392b";
const RED_GRADIENT = `linear-gradient(135deg, #922b21, ${RED})`;
// Matches the "Silka bold" heading treatment used on the lead details
// (manageProjectLog) page, so headings here read consistently with the rest
// of the app. Body text already inherits "Silka regular" globally via App.css.
const HEADING_FONT = "'Silka bold', 'Silka semiBold', sans-serif !important";

// Two-letter monogram for the owner cell.
const initialsOf = (name = "") =>
    String(name).trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";

const useStyles = makeStyles(() => ({
    page: { padding: 20, background: "#f6f7fb", minHeight: "100vh" },
    headerCard: {
        marginBottom: 20,
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 10px 28px rgba(196,83,31,0.2)",
        background: HEADER_GRADIENT,
        padding: "22px 26px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 16,
    },
    headerLeft: { display: "flex", alignItems: "center", gap: 16 },
    headerActions: { display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" },
    "@keyframes spin": { from: { transform: "rotate(0deg)" }, to: { transform: "rotate(360deg)" } },
    "@keyframes pulseDot": {
        "0%, 100%": { opacity: 1, transform: "scale(1)" },
        "50%": { opacity: 0.45, transform: "scale(0.82)" },
    },
    // Solid white with a dark ring: the ring defines the EDGE, since white on
    // the bright #ff9c66 end of the gradient is only about 2:1. The word
    // "Refresh" is what makes the control findable at all.
    refreshButton: {
        display: "inline-flex", alignItems: "center", gap: 7,
        padding: "8px 16px", borderRadius: 999, border: "none",
        background: "#fff", color: ORANGE_DARK,
        fontSize: 12.5, fontWeight: 800, letterSpacing: 0.2, fontFamily: "inherit",
        cursor: "pointer",
        boxShadow: "0 0 0 1px rgba(0,0,0,0.14), 0 3px 10px rgba(0,0,0,0.24)",
        transition: "background .18s ease, transform .18s ease, box-shadow .18s ease",
        "&:hover:not(:disabled)": {
            background: ORANGE_LIGHT, transform: "translateY(-1px)",
            boxShadow: "0 0 0 1px rgba(0,0,0,0.18), 0 6px 16px rgba(0,0,0,0.3)",
        },
        "&:active:not(:disabled)": { transform: "translateY(0)" },
        "&:disabled": { cursor: "wait", opacity: 0.85 },
    },
    refreshSpinning: { animation: "$spin 0.9s linear infinite" },
    lastUpdatedText: {
        display: "inline-flex", alignItems: "center", gap: 6,
        fontSize: 11, fontWeight: 600, color: "#fff",
        background: "rgba(0,0,0,0.42)", padding: "3px 10px", borderRadius: 999,
        whiteSpace: "nowrap",
    },
    liveDot: {
        width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
        background: "#FFD2B5", animation: "$pulseDot 2s ease-in-out infinite",
    },
    headerIconWrap: {
        width: 52,
        height: 52,
        borderRadius: "50%",
        background: "rgba(255,255,255,0.22)",
        border: "2px solid rgba(255,255,255,0.35)",
        boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
    },
    statChip: {
        background: "rgba(255,255,255,0.2)",
        color: "#fff",
        borderRadius: 20,
        padding: "7px 16px",
        fontWeight: 700,
        fontSize: 13,
        display: "flex",
        alignItems: "center",
        gap: 6,
        whiteSpace: "nowrap",
    },
    filterCard: {
        borderRadius: 16,
        boxShadow: "0 6px 20px rgba(17,24,39,0.06)",
        padding: "18px 22px",
        marginBottom: 20,
        background: "#fff",
    },
    sectionLabel: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        color: "#6b7280",
        fontSize: 12.5,
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: 0.4,
        marginBottom: 10,
    },
    filterRow: { display: "flex", flexWrap: "wrap", gap: 14, alignItems: "center" },
    field: {
        minWidth: 190,
        flex: "1 1 190px",
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: ORANGE },
        '& .MuiInputLabel-root.Mui-focused': { color: ORANGE_DARK },
    },
    dateField: {
        width: 225,
        flex: "0 0 auto",
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: ORANGE },
        '& .MuiInputLabel-root.Mui-focused': { color: ORANGE_DARK },
    },
    actionBtnBase: {
        borderRadius: 10,
        textTransform: "none",
        fontWeight: 600,
        boxShadow: "none",
        padding: "8px 20px",
        height: 40,
    },
    submitBtn: {
        color: "#fff",
        background: `linear-gradient(135deg, ${ORANGE_DARK}, ${ORANGE})`,
        "&:hover": { background: `linear-gradient(135deg, #a8441a, ${ORANGE_DARK})`, boxShadow: "0 6px 16px rgba(244,126,68,0.35)" },
        "&:disabled": { background: "rgba(0,0,0,0.12)", color: "rgba(0,0,0,0.38)" },
    },
    clearBtn: {
        color: "#6b7280",
        border: "1.5px solid #d8dee8",
        background: "#fff",
        "&:hover": { background: "#f5f6f8", borderColor: "#c3cad6" },
    },
    downloadBtn: {
        color: "#fff",
        background: GREEN_GRADIENT,
        "&:hover": { background: "linear-gradient(135deg, #0f5132, #146c43)", boxShadow: "0 6px 16px rgba(30,132,73,0.35)" },
    },
    tableCard: { borderRadius: 16, overflow: "hidden", boxShadow: "0 6px 20px rgba(17,24,39,0.06)", background: "#fff" },
    // overflowX hidden on purpose: with 8 columns the table fits, and letting
    // it scroll sideways again would hide the Action buttons off the right edge.
    tableWrap: { maxHeight: 675, overflowY: "auto", overflowX: "hidden" },
    tableFullWidth: { width: "100%", tableLayout: "fixed" },
    tableHeadCell: {
        // Solid, not a gradient: across a wide table the gradient's light end
        // left the right-hand headers washed out (white on #ff9c66 is only
        // ~2:1), and a flat band keeps every label at 4.64:1.
        // `!important` is still needed: MUI's stickyHeader rule paints its
        // own background on th.
        background: `${ORANGE_DARK} !important`,
        color: "#fff",
        fontWeight: 700,
        fontSize: 11.5,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        textAlign: "center",
        // NOT nowrap: a long header is what forced the table wider than the
        // viewport. Two short lines cost a few pixels of height and save a
        // horizontal scrollbar.
        lineHeight: 1.3,
        padding: "10px 8px",
        borderBottom: "none",
    },
    tableRow: {
        "&:nth-of-type(odd)": { backgroundColor: "#FBFBFA" },
        "&:hover": { backgroundColor: ORANGE_LIGHT, boxShadow: `inset 3px 0 0 ${ORANGE}` },
        transition: "background-color .12s ease, box-shadow .12s ease",
    },
    tableCellCss: {
        textAlign: 'center',
        fontSize: 13.5,
        color: "#2b3648",
        borderBottom: "1px solid #f1f2f5",
    },
    rankCell: { color: "#9aa1ac", fontWeight: 800, fontVariantNumeric: "tabular-nums" },
    // Identity, not decoration: the same owner recurs down the list, and an
    // initial makes a repeated name findable while scanning.
    personCell: { display: "flex", alignItems: "center", justifyContent: "center", gap: 8 },
    personAvatar: {
        width: 26, height: 26, borderRadius: "50%", flexShrink: 0,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: ORANGE_LIGHT, color: ORANGE_DARK,
        fontSize: 11, fontWeight: 800,
    },
    // The reason is why the lead is on this page at all, so it gets a chip
    // rather than being one more run of plain grey text.
    reasonChip: {
        display: "inline-flex", alignItems: "center",
        padding: "3px 10px", borderRadius: 999,
        background: "#eef2f8", color: "#2a4d7a",
        fontSize: 11.5, fontWeight: 700,
        maxWidth: 220, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
    },
    // Bounded with ellipsis so a long name cannot push the table wider than
    // the page; the full value is in the tooltip.
    customerName: {
        fontSize: 13, fontWeight: 600, color: "#2b3648",
        maxWidth: 200, margin: "0 auto",
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
    },
    reasonBlock: { display: "flex", flexDirection: "column", alignItems: "center", gap: 4, maxWidth: 210, margin: "0 auto" },
    reasonOther: {
        fontSize: 11, color: "#6b7280", maxWidth: 200,
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
    },
    dateStack: { lineHeight: 1.35 },
    dateMain: { fontSize: 12.5, fontWeight: 700, color: "#2b3648", whiteSpace: "nowrap" },
    dateSub: { fontSize: 11, color: "#9aa1ac", whiteSpace: "nowrap" },
    // A tinted pill with a launch glyph, matching the BotWot dashboard: the
    // lead number reads as the thing you click, not as underlined text.
    leadLink: {
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "3px 10px",
        borderRadius: 7,
        background: ORANGE_LIGHT,
        whiteSpace: "nowrap",
        color: ORANGE_DARK,
        fontWeight: 700,
        fontSize: 12.5,
        textDecoration: "none",
        transition: "background-color .15s ease",
        "&:hover": { background: "#ffe3d2", textDecoration: "none" },
    },
    attachmentIconBtn: {
        color: ORANGE_DARK,
        backgroundColor: ORANGE_LIGHT,
        transition: "transform .15s ease, background-color .15s ease",
        "&:hover": { backgroundColor: "#ffe3d2", transform: "scale(1.08)" },
    },
    recordingCell: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
    },
    approveBtn: {
        color: "#fff",
        background: GREEN_GRADIENT,
        "&:hover": { background: "linear-gradient(135deg, #0f5132, #146c43)", boxShadow: "0 6px 16px rgba(30,132,73,0.3)" },
    },
    rejectBtn: {
        color: RED,
        border: `1.5px solid ${RED}`,
        background: "#fff",
        "&:hover": { background: "#fdecea" },
    },
    emptyState: { padding: "60px 20px", textAlign: "center", color: "#9aa1ac" },
    emptyIconWrap: {
        width: 80,
        height: 80,
        borderRadius: "50%",
        background: ORANGE_LIGHT,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 14px",
    },
    dialogHeader: {
        color: "#fff",
        padding: "18px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
    },
    dialogHeaderTitle: { display: "flex", alignItems: "center", gap: 10 },
    dialogCloseBtn: {
        color: "rgba(255,255,255,0.9)",
        "&:hover": { backgroundColor: "rgba(255,255,255,0.15)" },
    },
}));

const MoveToMarketingApproval = (props) => {
    const buttonRef = useRef(null);
    const classes = useStyles();
    const { userDetails } = useSelector(state => state.user);
    const history = useHistory();

    const [storeDateFilter, setPivotDateFilters] = useState({ startDate: "", endDate: "", dateType: "leadAssignedDate" })
    const [m2mLead, setM2MLead] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState({});
    const [selectedAction, setSelectedAction] = useState('');
    const [reasonForApproval, setReasonForApproval] = useState('');
    const [reasonByAGMDGM, setReasonByAGMDGM] = useState('');
    const [junkReasonOptions, setJunkReasonOptions] = useState(junkReasons);
    const [junkReason, setJunkReason] = useState("");
    const [handoverDate, setHandoverDate] = useState("");
    const [reasonForRejection, setReasonForRejection] = useState('');
    const [filter, setFilter] = useState("ERP");
    const [searchInput, setSearchInput] = useState("");
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No'];
    const [commonLocation, setLocation] = useState([])
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedLocation, setSelectedLocation] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    // Local, button/table-level loaders instead of the app-wide Backdrop, so
    // Submit/Search/pagination give immediate, visible feedback right where
    // the click happened (same pattern used across the app's redesigned
    // pages this session).
    const [dataLoading, setDataLoading] = useState(false);
    // When the rows on screen were last pulled, so the header can say how stale
    // they are. Only set on a successful fetch - a failed refresh must not make
    // old rows look fresh.
    const [lastUpdated, setLastUpdated] = useState(null);
    // "Updated 4 minutes ago" is only true at the instant it renders, so a slow
    // tick re-renders it. 30s is plenty - moment rounds to the minute anyway.
    const [nowTick, setNowTick] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNowTick(Date.now()), 30000);
        return () => clearInterval(id);
    }, []);
    const [submittingAction, setSubmittingAction] = useState(false);
    // Tracks which row's attachment is currently playing (only one at a
    // time) - drives the custom play/pause icon and pauses whichever else
    // was playing before starting a new one. Only relevant for attachments
    // that are actually audio (see isAudioFile) - image attachments still
    // just get a download button.
    const [playingId, setPlayingId] = useState(null);
    const audioRefs = useRef({});

    const isAudioFile = (url) => /\.(mp3|wav|m4a|ogg|aac|webm|opus)(\?.*)?$/i.test(url || "");

    const togglePlay = (rowId) => {
        const audio = audioRefs.current[rowId];
        if (!audio) return;

        if (playingId === rowId) {
            audio.pause();
            setPlayingId(null);
            return;
        }

        Object.entries(audioRefs.current).forEach(([id, el]) => {
            if (id !== rowId && el) el.pause();
        });

        audio.play();
        setPlayingId(rowId);
    };

    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
    }
    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
        // handleExpData(newvalue)
    }
     const locations = async () => {
            props.setLoading(true);
            try {
                let response = await HttpService.getLocation();
                const matchedUsers = response.data.filter(user => {
                    return userDetails.selectedLocation.includes(user._id);
                });
                setLocation(matchedUsers)
            } catch (error) {
                console.error("Error fetching experience centers:", error);
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
    }
       const expCenters = async () => {
            props.setLoading(true);
            try {
                let response = await HttpService.getExpericenCenters();
                const matchedUsers = response.data.filter(user => {
                    return userDetails.experienceCenterId.includes(user._id);
                });
                setExpCenter(matchedUsers)
            } catch (error) {
                console.error("Error fetching experience centers:", error);
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
        }
       useEffect(() => {
           locations()
           expCenters()
           // eslint-disable-next-line
       }, [])
    // const [cities, setCities] = useState([]);
    // const [expCenters, setExpCenters] = useState([]);
    // const [managerOfSalesTeam, setManagerOfSalesTeam] = useState([]);
    // const [salesManagerList, setSalesManagerList] = useState([]);
    // const [dupManagerOfSalesTeam, setDupManagerOfSalesTeam] = useState([]);
    // const [ecTransferData, setEcTransferData] = useState({});
    // const [assignToManager, setAssignToManager] = useState("");
    // const getDataOnPageLoading = async ()=>{
    //     const result = await HttpService.getm2mleads();
    //     setM2MLead(result.data);

    // }

    // useEffect(()=>{
    //     getLocationList();
    // },[])

    const getDataOnPageLoading = async (currentPage = page, limit = rowsPerPage, filter, selectedSearchType, searchInput, addLocation, addExpCenter) => {
        setDataLoading(true);
        try {
            let expCenterData = addExpCenter?.map((el) => el._id)
            let locationData = addLocation?.map((el) => el._id)
            let obj = {
                selectedExperienceCenter: expCenterData ? expCenterData : "",
                selectedlocation: locationData ? locationData : "",
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                dateType: storeDateFilter.dateType,
                page: currentPage + 1, // 1-indexed
                limit: limit,
                filter: filter,
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput ? searchInput.toUpperCase() : ""
            }
            const result = await HttpService.getm2mleads(obj);
            setM2MLead(result.data?.data || []);
            setTotalCount(result.data?.total || 0);
            // Inside the try, after the assignments: a fetch that threw leaves
            // the previous timestamp alone rather than vouching for stale rows.
            setLastUpdated(new Date());
        } catch (err) {
            console.error("Error fetching leads:", err);
        }
        setDataLoading(false);
    };

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDateFilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        getDataOnPageLoading(page, rowsPerPage, filter, selectedSearchType, searchInput, selectedLocation, selectedExperienceCenter)
    }

    useEffect(() => {
        getDataOnPageLoading(page, rowsPerPage, filter, selectedSearchType, searchInput, selectedLocation, selectedExperienceCenter)
        // eslint-disable-next-line
    }, [page, rowsPerPage, filter, selectedLocation, selectedExperienceCenter]);

    const updateLeadInM2M = async () => {
        setSubmittingAction(true);
        try {
            if (!selectedLead?._id) return;

            let result;

            if (selectedAction === 'approve') {
                const isAGMorDGM = userDetails.roles.some(
                    role => role.name === "AGM Sales" || role.name === "DGM Sales"
                );

                const payload = {
                    leadId: selectedLead._id,
                };

                if (isAGMorDGM) {
                    // AGM / DGM → send only this field
                    payload.reason = reasonByAGMDGM;
                } else {
                    // Others → send normal approval fields
                    payload.reason = reasonForApproval;
                    payload.junkReason = junkReason || "";
                    payload.handoverDate = handoverDate || null;
                }

                result = await HttpService.updateM2MApproval(payload);
            }

            if (selectedAction === 'reject') {
                const payload = {
                    leadId: selectedLead._id,
                    reasonForRejection
                };

                // if (
                //     selectedLead?.moveToMarketingReason === "Experience Center Transfer (EC Transfer)"
                // ) {
                //     payload.city = ecTransferData?.city;
                //     payload.experienceCenterId = ecTransferData?.experienceCenterId;
                //     payload.assignTo = ecTransferData?.assignTo;
                //     payload.assignToName = ecTransferData?.assignToName;
                //     payload.departmentId = ecTransferData?.departmentId;
                //     payload.teamId = ecTransferData?.teamId;
                //     payload.teamName = ecTransferData?.teamName;
                // }

                result = await HttpService.updateM2Mrejection(payload);
            }

            props.setSnackInfo(result?.data?.message || "Action completed", "success");

            setOpenConfirmationModal(false);
            setJunkReason("");
            setHandoverDate("");
            getDataOnPageLoading();

        } catch (err) {
            console.error("updateLeadInM2M error →", err);
            props.setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
        }
        setSubmittingAction(false);
    };

    const openModalAction = (action, lead) => {
        try {
            setSelectedLead(lead);
            setSelectedAction(action);
            setOpenConfirmationModal(true);

            // if (
            //     action === "reject" &&
            //     lead?.moveToMarketingReason === "Experience Center Transfer (EC Transfer)"
            // ) {
            //     getSalesManagerList();
            // }
        } catch (error) {
            console.error("error", error);
        }
    };

    // const getLocationList = async () => {
    //     props.setLoading(true)
    //     try {
    //         const response = await HttpService.getLocationList()
    //         setCities(response.data)
    //     } catch (error) {
    //         props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
    //     }
    //     props.setLoading(false)
    // };

    // const getExperienceCenterByLocation = async (e) => {
    //     setEcTransferData({ ...ecTransferData, [e.target.name]: e.target.value });

    //     props.setLoading(true);
    //     try {
    //         const response = await HttpService.getExpericenCentersByLocation(e.target.value);
    //         setExpCenters(response.data);
    //     } catch (error) {
    //         props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error");
    //     }
    //     props.setLoading(false);
    // };


    // const getManagerBasedOnLocation = (e) => {
    //     setEcTransferData({ ...ecTransferData, [e.target.name]: e.target.value });

    //     let salesManagerArr = [];

    //     dupManagerOfSalesTeam.forEach(ele => {
    //         ele.experienceCenterId.forEach(ele1 => {
    //             if (ele1._id === e.target.value) {
    //                 salesManagerArr.push(ele);
    //             }
    //         });
    //     });

    //     setManagerOfSalesTeam(salesManagerArr);
    // };

    // const checkAssignDetail = (e) => {
    //     if (e.target.value) {
    //         setAssignToManager(e.target.value);

    //         let teamDetail = [];

    //         dupManagerOfSalesTeam.forEach(ele => {
    //             if (ele?._id === e.target.value) {
    //                 teamDetail.push(ele);
    //             }
    //         });

    //         const selected = teamDetail[0];

    //         setEcTransferData({
    //             ...ecTransferData,
    //             assignToName: selected.name,
    //             assignTo: selected._id,
    //             departmentId: selected.departmentId._id,
    //             teamId: selected.teamId._id,
    //             teamName: selected.teamId.name
    //         });
    //     }
    // };

    // const getSalesManagerList = async () => {
    //     props.setLoading(true)
    //     try {
    //         const result = await HttpService.getUsers()
    //         let salesArr = [];
    //         let salesManagerArr = [];
    //         let activeTeamUser = result.data.filter(ele => ele.isActive === true);
    //         activeTeamUser.forEach(ele => {
    //             if (ele.roles?.find(role => role.name === ROLENAME.AssistantSalesManager) && ele?.teamId?.isActive === true ) {
    //                 salesArr.push(ele);
    //             } else if (ele.roles?.find(role => role.name === ROLENAME.SalesManager) && ele?.teamId?.assistantManagers?.length === 0 && ele?.teamId?.isActive === true ) {
    //                 salesArr.push(ele);
    //             }
    //         })
    //         dupManagerOfSalesTeam.forEach(ele => {
    //             ele.experienceCenterId.forEach(ele1 => {
    //                 if (ele1._id === ecTransferData.experienceCenterId._id) {
    //                     salesManagerArr.push(ele)
    //                 }
    //             })
    //         })
    //         setSalesManagerList(salesManagerArr)
    //         setDupManagerOfSalesTeam(salesArr);
    //     } catch (error) {
    //         props.setSnackInfo(error?.response?.data ?? "Something went wrong", "error")
    //     }
    //     props.setLoading(false)
    // };

    const downloadExcel = () => {
        const data = m2mLead.map(lead => {
            const formattedCreatedAtDate = new Date(lead.createdAt).toLocaleDateString('en-GB'); // dd/mm/yyyy
            const finalCreatedAtDate = formattedCreatedAtDate.replace(/\//g, '-'); // dd-mm-yyyy

            const formattedLeadAssignedDate = new Date(lead?.leadAssigned).toLocaleDateString('en-GB'); // dd/mm/yyyy
            const finalLeadAssignedDate = formattedLeadAssignedDate.replace(/\//g, '-'); // dd-mm-yyyy

            return {
                CreatedAt: finalCreatedAtDate,
                LeadNo: lead?.lead_no,
                ClientName: lead?.customerId ? lead?.customerId?.name : "NA",
                // Email: lead?.customerId ? lead?.customerId?.email : "NA",
                // ContactNo: lead?.customerId ? lead?.customerId?.contact_no : "NA",
                EC: lead?.experienceCenterId?.name,
                AssignedTo: lead?.assignTo ? lead?.assignTo?.name : "NA",
                AudioImageFile: lead?.moveToMarketingFile
                    ? { text: 'Download Audio', hyperlink: lead?.moveToMarketingFile }
                    : { text: 'No Audio', hyperlink: '' },
                MoveToMarketingReason: lead?.moveToMarketingReason ? lead?.moveToMarketingReason : "NA",
                MoveToMarketingOtherReason: lead?.moveToMarketingOtherReason ? lead?.moveToMarketingOtherReason : "NA",
                HoldRevokeDate: (lead.holdRevokeDate || lead.handoverDate)
                    ? moment(lead.holdRevokeDate || lead.handoverDate).format('DD-MM-YYYY') : "NA",
                GrandTotal: lead?.grandTotal,
                LeadAssigned: finalLeadAssignedDate
            };
        });

        // Declared once and used for BOTH the sheet layout and the hyperlink
        // column, because hardcoding the letter has already broken this export
        // once: removing the Email and ContactNo columns shifted
        // AudioImageFile from H to F, but the hyperlink code kept writing to H.
        // The effect was that every recording link landed on top of
        // MoveToMarketingOtherReason - destroying that column in the download -
        // while the real attachment column came out blank.
        const EXPORT_HEADER = [
            "CreatedAt", "LeadNo", "ClientName", "EC", "AssignedTo",
            "AudioImageFile", "MoveToMarketingReason", "MoveToMarketingOtherReason",
            "HandoverDate", "GrandTotal", "LeadAssigned",
        ];

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, { header: EXPORT_HEADER });

        // Derived, never hardcoded - reordering EXPORT_HEADER now moves the
        // links with it.
        const audioCol = XLSX.utils.encode_col(EXPORT_HEADER.indexOf("AudioImageFile"));

        ws[`${audioCol}1`].v = "Audio/Image File (Click to Download)";

        data.forEach((lead, index) => {
            const rowNum = index + 2; // row 1 is the header
            const audioCell = `${audioCol}${rowNum}`;
            if (lead.AudioImageFile.hyperlink) {
                ws[audioCell] = {
                    t: 's',
                    v: lead.AudioImageFile.text,
                    l: { Target: lead.AudioImageFile.hyperlink },
                };
            } else {
                // Still written explicitly: json_to_sheet leaves the raw
                // { text, hyperlink } object in this cell, which has no `t`/`v`
                // and so writes out blank.
                ws[audioCell] = { t: 's', v: lead.AudioImageFile.text };
            }
        });

        XLSX.utils.book_append_sheet(wb, ws, "Leads");
        XLSX.writeFile(wb, "M2M_Leads.xlsx");
    };

    const handleClick = () => {
        if (buttonRef.current) {
            downloadExcel();
        }
    };

    const handleChangePage = (event, newPage) => setPage(newPage);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // reset to first page
    };

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }
    const handleSearch = async (value) => {
        getDataOnPageLoading(page, rowsPerPage, filter, selectedSearchType, value, selectedLocation, selectedExperienceCenter)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        getDataOnPageLoading(page, rowsPerPage, filter, "", "")
    }

    const handleSelectJunkReason = (event) => {
        setJunkReason(event.target.value);
    };

    // const isRejectInvalid =
    //     selectedAction === 'reject' &&
    //     (
    //         !reasonForRejection ||
    //         (
    //             selectedLead?.moveToMarketingReason === "Experience Center Transfer (EC Transfer)" &&
    //             (
    //                 !ecTransferData?.city ||
    //                 !ecTransferData?.experienceCenterId ||
    //                 !ecTransferData?.assignTo
    //             )
    //         )
    //     );

    const isAGMorDGMUser = userDetails?.roles?.find(
        role => role.name === "DGM Sales" || role.name === "AGM Sales"
    );

    return (
        <div className={classes.page}>
            {/* HEADER */}
            <Box className={classes.headerCard}>
                <Box className={classes.headerLeft}>
                    <Box className={classes.headerIconWrap}>
                        <AssignmentOutlinedIcon style={{ color: "#fff", fontSize: 26 }} />
                    </Box>
                    <Box>
                        <Typography style={{ color: "#fff", fontFamily: HEADING_FONT, fontSize: 21, margin: 0 }}>
                            Move To Marketing Lead Approval
                        </Typography>
                        <Typography style={{ color: "rgba(255,255,255,0.88)", fontSize: 13.5, marginTop: 4 }}>
                            Review and action leads sent from Sales to Marketing
                        </Typography>
                    </Box>
                </Box>

                <Box className={classes.headerActions}>
                    <Box className={classes.statChip}>
                        <AssignmentOutlinedIcon style={{ fontSize: 15 }} />
                        {totalCount} Pending Lead{totalCount === 1 ? "" : "s"}
                    </Box>

                    <Tooltip
                        title={
                            lastUpdated
                                ? `Last pulled at ${moment(lastUpdated).format("DD MMM YYYY, hh:mm:ss A")} — click to fetch the latest leads`
                                : "Fetch the latest leads"
                        }
                    >
                        {/* A labelled button rather than an IconButton: the word
                            "Refresh" is what makes the control findable, and a
                            tooltip alone only helps people who already hovered.
                            The span is required because a disabled button fires no
                            mouse events, so the tooltip would die mid-refresh. */}
                        <span style={{ display: "inline-flex" }}>
                            <button
                                type="button"
                                className={classes.refreshButton}
                                // Replays the CURRENT page, filters and search, so
                                // refreshing never silently resets what you were
                                // looking at.
                                onClick={() => getDataOnPageLoading(page, rowsPerPage, filter, selectedSearchType, searchInput, selectedLocation, selectedExperienceCenter)}
                                disabled={dataLoading}
                            >
                                <RefreshIcon
                                    className={dataLoading ? classes.refreshSpinning : undefined}
                                    style={{ fontSize: 17 }}
                                />
                                {dataLoading ? "Refreshing…" : "Refresh"}
                            </button>
                        </span>
                    </Tooltip>

                    {lastUpdated && (
                        <Box className={classes.lastUpdatedText}>
                            <span className={classes.liveDot} />
                            {/* Relative beats a clock time: it answers "is this
                                stale?" without the reader doing the arithmetic. */}
                            {dataLoading ? "Fetching latest…" : `Updated ${moment(lastUpdated).from(nowTick)}`}
                        </Box>
                    )}
                </Box>
            </Box>

            {/* FILTERS */}
            <Box className={classes.filterCard}>
                <Typography className={classes.sectionLabel}>
                    <TuneIcon style={{ fontSize: 15 }} />
                    Filters
                </Typography>
                <Box className={classes.filterRow} style={{ marginBottom: 18 }}>
                    {isAGMorDGMUser && (
                        <>
                            <Autocomplete
                                multiple
                                value={selectedLocation}
                                onChange={handleMultipleLocationData}
                                options={commonLocation}
                                getOptionLabel={(option) => option.name}
                                className={classes.field}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Location"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <RoomOutlinedIcon style={{ fontSize: 16, color: "#9aa1ac", marginRight: 4 }} />
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />

                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                onChange={handleMultipleExpData}
                                options={commonExpCenter}
                                getOptionLabel={(option) => option.name}
                                className={classes.field}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Exp-Center"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                            ...params.InputProps,
                                            startAdornment: (
                                                <>
                                                    <StorefrontOutlinedIcon style={{ fontSize: 16, color: "#9aa1ac", marginRight: 4 }} />
                                                    {params.InputProps.startAdornment}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            />
                        </>
                    )}

                    <TextField
                        select
                        label="Date Type"
                        name="dateType"
                        value={storeDateFilter.dateType}
                        onChange={storePivotDate}
                        SelectProps={{ native: true }}
                        variant="outlined"
                        size="small"
                        className={classes.dateField}
                    >
                        <option value="leadAssignedDate">Lead Assigned</option>
                        <option value="createdAt">Created Date</option>
                    </TextField>

                    <TextField
                        type="date"
                        label="From"
                        name="startDate"
                        value={storeDateFilter.startDate}
                        onChange={storePivotDate}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        size="small"
                        className={classes.dateField}
                    />

                    <TextField
                        type="date"
                        label="To"
                        name="endDate"
                        value={storeDateFilter.endDate}
                        onChange={storePivotDate}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        size="small"
                        className={classes.dateField}
                    />

                    <Button
                        variant="contained"
                        onClick={handlePivotDateFilter}
                        disabled={dataLoading}
                        className={`${classes.actionBtnBase} ${classes.submitBtn}`}
                        startIcon={dataLoading ? <CircularProgress size={15} style={{ color: "#fff" }} /> : <DateRangeOutlinedIcon />}
                    >
                        {dataLoading ? "Loading..." : "Submit"}
                    </Button>
                </Box>

                {/* Search Section */}
                <Typography className={classes.sectionLabel}>
                    <SearchIcon style={{ fontSize: 15 }} />
                    Search
                </Typography>
                <Box className={classes.filterRow}>
                    <TextField
                        select
                        label="Search Type"
                        value={selectedSearchType}
                        name="searchType"
                        onChange={(e) => handleSearchType(e.target.value)}
                        variant="outlined"
                        size="small"
                        className={classes.field}
                    >
                        {searchTypes?.map((el, index) => (
                            <MenuItem key={index} value={el}>
                                {el}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        label="Enter the input"
                        name="searched"
                        size="small"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                        variant="outlined"
                        className={classes.field}
                        style={{ flex: "2 1 260px" }}
                    />

                    <Button
                        disabled={!selectedSearchType || !searchInput || dataLoading}
                        variant="contained"
                        onClick={() => handleSearch(searchInput.toUpperCase())}
                        className={`${classes.actionBtnBase} ${classes.submitBtn}`}
                        startIcon={dataLoading ? <CircularProgress size={15} style={{ color: "#fff" }} /> : <SearchIcon />}
                    >
                        {dataLoading ? "Loading..." : "Search"}
                    </Button>

                    <Button
                        variant="outlined"
                        onClick={clearDateFilter}
                        disabled={dataLoading}
                        className={`${classes.actionBtnBase} ${classes.clearBtn}`}
                        startIcon={<ClearAllIcon />}
                    >
                        Clear
                    </Button>
                </Box>
            </Box>

            {/* ACTIONS ROW */}
            <Box className={classes.filterRow} style={{ marginBottom: 20 }}>
                <Button
                    ref={buttonRef}
                    onClick={handleClick}
                    variant="contained"
                    className={`${classes.actionBtnBase} ${classes.downloadBtn}`}
                    startIcon={<GetAppIcon />}
                >
                    Download Excel
                </Button>

                {!userDetails.roles.some(
                    role => role.name === "AGM Sales" || role.name === "DGM Sales"
                ) && (
                        <FormControl variant="outlined" size="small" className={classes.field} style={{ minWidth: 190, flex: "0 0 220px" }}>
                            <InputLabel>Approval Channel</InputLabel>
                            <Select
                                value={filter}
                                onChange={(e) => setFilter(e.target.value)}
                                label="Approval Channel"
                            >
                                <MenuItem value="ERP">ERP</MenuItem>
                                <MenuItem value="BotWot">BotWot</MenuItem>
                                <MenuItem value="AGM/DGM">AGM/DGM</MenuItem>
                            </Select>
                        </FormControl>
                    )}
            </Box>

            {/* TABLE */}
            <Box className={classes.tableCard}>
                <TableContainer className={classes.tableWrap}>
                    <Table stickyHeader aria-label="sticky table" className={classes.tableFullWidth}>
                        <TableHead>
                            <TableRow>
                                {/* 8 columns, not 11. Name/Email/Contact are one
                                    customer block and the two reasons are one
                                    reason block - three columns removed is what
                                    lets the table fit without a horizontal
                                    scrollbar. Nothing is dropped; the fields are
                                    stacked instead of spread. */}
                                <TableCell className={classes.tableHeadCell} style={{ width: 52 }}>#</TableCell>
                                <TableCell className={classes.tableHeadCell}>Customer</TableCell>
                                <TableCell className={classes.tableHeadCell}>Lead No.</TableCell>
                                <TableCell className={classes.tableHeadCell}>Assigned To</TableCell>
                                <TableCell className={classes.tableHeadCell}>Reason</TableCell>
                                <TableCell className={classes.tableHeadCell}>Handover</TableCell>
                                <TableCell className={classes.tableHeadCell}>Attachment</TableCell>
                                <TableCell className={classes.tableHeadCell}>Action</TableCell>
                                {/* <TableCell className={classes.tableHeadCell}>
                                    {filter === "BotWot" ? "Status" : "Action"}
                                </TableCell> */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataLoading ? (
                                <TableRow>
                                    <TableCell colSpan={8} style={{ border: "none", textAlign: "center", padding: "50px 0" }}>
                                        <CircularProgress size={30} style={{ color: ORANGE }} />
                                        <Typography style={{ color: "#9aa1ac", marginTop: 10 }}>Loading leads...</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : m2mLead.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={8} style={{ border: "none" }}>
                                        <Box className={classes.emptyState}>
                                            <Box className={classes.emptyIconWrap}>
                                                <InboxOutlinedIcon style={{ fontSize: 36, color: ORANGE_DARK }} />
                                            </Box>
                                            <Typography style={{ fontWeight: 600, color: "#7d8794" }}>
                                                No leads pending approval
                                            </Typography>
                                            <Typography variant="body2" style={{ color: "#a4abb5", marginTop: 4 }}>
                                                Try adjusting your filters or date range.
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                m2mLead.map((row, i) => (
                                    <TableRow key={row._id} className={classes.tableRow}>
                                        <TableCell className={`${classes.tableCellCss} ${classes.rankCell}`}>{(page * rowsPerPage) + i + 1}</TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {/* Name only. Email and phone were dropped
                                                here to match the Excel export, which
                                                stopped carrying them - the screen and
                                                the sheet should expose the same
                                                customer detail, not different amounts
                                                of it. */}
                                            {row?.customerId?.name ? (
                                                <Tooltip title={row.customerId.name}>
                                                    <div className={classes.customerName}>{row.customerId.name}</div>
                                                </Tooltip>
                                            ) : <span style={{ color: "#9aa1ac" }}>N/A</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {row?.lead_no ? (
                                                <Tooltip title={`Open lead ${row.lead_no} in a new tab`}>
                                                    <Link to={`/project-logs/${row?._id}`} target="_blank" rel="noopener noreferrer" className={classes.leadLink}>
                                                        {row.lead_no}
                                                        <OpenInNewIcon style={{ fontSize: 11 }} />
                                                    </Link>
                                                </Tooltip>
                                            ) : <span style={{ color: "#9aa1ac" }}>N/A</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {row?.assignTo?.name ? (
                                                <div className={classes.personCell}>
                                                    <span className={classes.personAvatar}>{initialsOf(row.assignTo.name)}</span>
                                                    <span>{row.assignTo.name}</span>
                                                </div>
                                            ) : <span style={{ color: "#9aa1ac" }}>N/A</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {row?.moveToMarketingReason || row?.moveToMarketingOtherReason ? (
                                                <div className={classes.reasonBlock}>
                                                    {row?.moveToMarketingReason && (
                                                        <Tooltip title={row.moveToMarketingReason}>
                                                            <span className={classes.reasonChip}>{row.moveToMarketingReason}</span>
                                                        </Tooltip>
                                                    )}
                                                    {row?.moveToMarketingOtherReason && (
                                                        <Tooltip title={row.moveToMarketingOtherReason}>
                                                            <span className={classes.reasonOther}>{row.moveToMarketingOtherReason}</span>
                                                        </Tooltip>
                                                    )}
                                                </div>
                                            ) : <span style={{ color: "#9aa1ac" }}>N/A</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {(row?.holdRevokeDate || row?.handoverDate) ? (
                                                <div className={classes.dateStack}>
                                                    <div className={classes.dateMain}>{moment(row.holdRevokeDate || row.handoverDate).format('DD MMM YYYY')}</div>
                                                    <div className={classes.dateSub}>{moment(row.holdRevokeDate || row.handoverDate).fromNow()}</div>
                                                </div>
                                            ) : <span style={{ color: "#9aa1ac" }}>N/A</span>}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            {!row.moveToMarketingFile ? (
                                                <Tooltip title="No attachment">
                                                    <span>
                                                        <IconButton size="small" disabled>
                                                            <GraphicEqOutlinedIcon style={{ fontSize: 18 }} />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>
                                            ) : isAudioFile(row.moveToMarketingFile) ? (
                                                <div className={classes.recordingCell}>
                                                    <Tooltip title={playingId === row._id ? "Pause recording" : "Play recording"}>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => togglePlay(row._id)}
                                                            className={classes.attachmentIconBtn}
                                                        >
                                                            {playingId === row._id ? <PauseRoundedIcon style={{ fontSize: 18 }} /> : <PlayArrowRoundedIcon style={{ fontSize: 18 }} />}
                                                        </IconButton>
                                                    </Tooltip>
                                                    <audio
                                                        ref={(el) => { audioRefs.current[row._id] = el; }}
                                                        src={row.moveToMarketingFile}
                                                        preload="none"
                                                        onEnded={() => setPlayingId(null)}
                                                        style={{ display: "none" }}
                                                    />
                                                    <Tooltip title="Download attachment">
                                                        <IconButton
                                                            size="small"
                                                            component="a"
                                                            href={row.moveToMarketingFile}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className={classes.attachmentIconBtn}
                                                        >
                                                            <GetAppIcon style={{ fontSize: 16 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                            ) : (
                                                <Tooltip title="Download attachment">
                                                    <IconButton
                                                        size="small"
                                                        component="a"
                                                        href={row.moveToMarketingFile}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className={classes.attachmentIconBtn}
                                                    >
                                                        <GetAppIcon style={{ fontSize: 18 }} />
                                                    </IconButton>
                                                </Tooltip>
                                            )}
                                        </TableCell>
                                        <TableCell className={classes.tableCellCss}>
                                            <Box style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    onClick={() => openModalAction("approve", row)}
                                                    className={`${classes.actionBtnBase} ${classes.approveBtn}`}
                                                    style={{ padding: "6px 14px", height: "auto" }}
                                                    startIcon={<CheckCircleOutlineIcon />}
                                                >
                                                    Approve
                                                </Button>

                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    onClick={() => openModalAction("reject", row)}
                                                    className={`${classes.actionBtnBase} ${classes.rejectBtn}`}
                                                    style={{ padding: "6px 14px", height: "auto" }}
                                                    startIcon={<HighlightOffIcon />}
                                                >
                                                    Reject
                                                </Button>
                                            </Box>
                                        </TableCell>
                                        {/* <TableCell className={classes.tableCellCss}>
                                            {filter === "BotWot" ? (
                                                <>
                                                    Sent for Approval
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={() => openModalAction("approve", row)}
                                                        style={{ marginLeft: 1 }}
                                                    >
                                                        Approve
                                                    </Button>

                                                    <Button
                                                        color="secondary"
                                                        variant="outlined"
                                                        onClick={() => openModalAction("reject", row)}
                                                        style={{ marginLeft: 100 }}
                                                    >
                                                        Reject
                                                    </Button>
                                                </>
                                            ) : row.moveToMarketingFromSmApproval === "Sent to BotWot For M2M" ? (
                                                <>Sent for Approval</>
                                            ) : row.moveToMarketingFromSmApproval === "Approved By Customer via BotWot" ? (
                                                <>Approved</>
                                            ) : row.moveToMarketingFromSmApproval === "Rejected By Customer via BotWot" ? (
                                                <>Rejected</>
                                            ) : (
                                                <>
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                        onClick={() => openModalAction("approve", row)}
                                                        style={{ marginLeft: 1 }}
                                                    >
                                                        Approve
                                                    </Button>

                                                    <Button
                                                        color="secondary"
                                                        variant="outlined"
                                                        onClick={() => openModalAction("reject", row)}
                                                        style={{ marginLeft: 100 }}
                                                    >
                                                        Reject
                                                    </Button>
                                                </>
                                            )}
                                        </TableCell> */}
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={totalCount}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[50, 100, 200, { label: 'All', value: totalCount }]}
                />
            </Box>

            {/* APPROVE / REJECT DIALOG */}
            <Dialog
                open={openConfirmationModal}
                onClose={() => !submittingAction && setOpenConfirmationModal(false)}
                aria-labelledby="form-dialog-title"
                maxWidth="sm"
                fullWidth
                PaperProps={{ style: { borderRadius: 16, overflow: "hidden" } }}
            >
                <Box
                    className={classes.dialogHeader}
                    style={{ background: selectedAction === 'reject' ? RED_GRADIENT : GREEN_GRADIENT }}
                >
                    <Box className={classes.dialogHeaderTitle}>
                        {selectedAction === 'reject' ? <HighlightOffIcon style={{ fontSize: 22 }} /> : <CheckCircleOutlineIcon style={{ fontSize: 22 }} />}
                        <Typography style={{ fontFamily: HEADING_FONT, fontSize: 17 }}>
                            {selectedAction === 'reject' ? "Reject Lead" : "Approve Lead"}
                        </Typography>
                    </Box>
                    <IconButton
                        size="small"
                        className={classes.dialogCloseBtn}
                        onClick={() => setOpenConfirmationModal(false)}
                        disabled={submittingAction}
                    >
                        <CloseIcon style={{ fontSize: 18 }} />
                    </IconButton>
                </Box>

                <DialogContent style={{ paddingTop: 20 }}>
                    {selectedAction === 'approve' && (
                        <>
                            {userDetails.roles.some(
                                role => role.name === "AGM Sales" || role.name === "DGM Sales"
                            ) ? (
                                <TextField
                                    id="approval-reason-box"
                                    onChange={(e) => setReasonByAGMDGM(e.target.value)}
                                    value={reasonByAGMDGM}
                                    fullWidth
                                    variant="outlined"
                                    label="Reason for Approval"
                                />
                            ) : (
                                <>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        options={['Junk', 'Hold', 'To Be Called']}
                                        getOptionLabel={(option) => option}
                                        onChange={(e, v) => setReasonForApproval(v)}
                                        value={reasonForApproval}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Reason for Lost" variant="outlined" fullWidth />
                                        )}
                                    />

                                    {/* Junk Reason Dropdown */}
                                    {reasonForApproval === "Junk" && (
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            style={{ marginTop: 16 }}
                                        >
                                            <InputLabel id="select-reason-label">
                                                Junk Reason
                                            </InputLabel>

                                            <Select
                                                labelId="select-reason-label"
                                                id="select-junk-reason"
                                                value={junkReason}
                                                label="Junk Reason"
                                                onChange={handleSelectJunkReason}
                                                size="small"
                                            >
                                                {junkReasonOptions.map((row, i) => (
                                                    <MenuItem
                                                        key={i}
                                                        value={row.name}
                                                    >
                                                        {row.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}

                                    {/* Hand Over Date (Only if Hold) */}
                                    {reasonForApproval === "Hold" && (
                                        <TextField
                                            id="handoverDate"
                                            name="handoverDate"
                                            label="Hand Over Date"
                                            type="date"
                                            variant="outlined"
                                            value={handoverDate}
                                            onChange={(e) => setHandoverDate(e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            fullWidth
                                            margin="normal"
                                        />
                                    )}
                                </>
                            )}
                        </>
                    )}

                    {selectedAction === 'reject' && (
                        <>
                            <TextField
                                id="rejection-reason-box"
                                onChange={(e) => setReasonForRejection(e.target.value)}
                                value={reasonForRejection}
                                fullWidth
                                variant="outlined"
                                label="Reason for Rejection"
                            />

                            {/* {selectedLead?.moveToMarketingReason === "Experience Center Transfer (EC Transfer)" && (
                                <>
                                    <FormControl fullWidth style={{ marginBottom: 20 }}>
                                        <TextField
                                            select
                                            name="city"
                                            value={ecTransferData?.city || ""}
                                            label="City *"
                                            onChange={getExperienceCenterByLocation}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {cities?.map((data, i) => (
                                                <MenuItem value={data._id} key={i}>{data.name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>

                                    <FormControl fullWidth style={{ marginBottom: 20 }}>
                                        <TextField
                                            select
                                            name="experienceCenterId"
                                            value={ecTransferData?.experienceCenterId || ""}
                                            label="Experience Center *"
                                            onChange={getManagerBasedOnLocation}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {expCenters?.map((data, i) => (
                                                <MenuItem value={data._id} key={i}>{data.name}</MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>

                                    <FormControl fullWidth style={{ marginBottom: 20 }}>
                                        <TextField
                                            select
                                            name="assignToManager"
                                            value={assignToManager || ""}
                                            label="Assign To Team"
                                            onChange={checkAssignDetail}
                                            variant="outlined"
                                            size="small"
                                        >
                                            {managerOfSalesTeam?.map((data) => (
                                                <MenuItem key={data._id} value={data._id}>
                                                    {`${data?.teamId?.name} - ${data?.name}`}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </FormControl>
                                </>
                            )} */}
                        </>
                    )}
                </DialogContent>
                <DialogActions style={{ padding: "14px 24px 20px" }}>
                    <Button
                        onClick={() => setOpenConfirmationModal(false)}
                        variant="outlined"
                        className={classes.clearBtn}
                        disabled={submittingAction}
                    >
                        Cancel
                    </Button>
                    {/* <Button
                        onClick={updateLeadInM2M}
                        disabled={
                            (selectedAction === 'approve' &&
                                (reasonByAGMDGM === '' &&
                                    (!reasonForApproval || reasonForApproval === '')))
                            || isRejectInvalid
                        }
                        color="primary"
                        variant="contained"
                    > */}
                    <Button
                        onClick={updateLeadInM2M}
                        disabled={
                            submittingAction ||
                            (selectedAction === 'approve' && (reasonByAGMDGM === '' && (reasonForApproval === '' || reasonForApproval === null))) ||
                            (selectedAction === 'reject' && (reasonForRejection === '' || reasonForRejection === null))
                        }
                        variant="contained"
                        className={classes.actionBtnBase}
                        style={{ background: selectedAction === 'reject' ? RED_GRADIENT : GREEN_GRADIENT, color: "#fff" }}
                        startIcon={submittingAction ? <CircularProgress size={16} style={{ color: "#fff" }} /> : null}
                    >
                        {submittingAction ? "Submitting..." : "Submit"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(MoveToMarketingApproval)
